import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { HomeFriendsImg } from "@/assets"
import { useModals } from "@/modals"
import { useAppSelector } from "@/store"
import { useCreateFriendLobbyMutation } from "@/store/apis/friendLobbyAPI"
import { FindMatchSelectors } from "@/store/slices/findMatch"
import { HomeMenuItem, IWithFriends } from ".."
import styles from "./WithFriends.module.scss"

export const WithFriends: FC<IWithFriends> = ({ className, ...rest }) => {
  const { t } = useTranslation()
  const { openModal } = useModals()

  const isMatchSearching = useAppSelector(
    FindMatchSelectors.selectFindMatchIsSearching()
  )

  const [createFriendLobby, { isLoading: isCreating }] =
    useCreateFriendLobbyMutation()

  const handleCreateLink = async () => {
    try {
      await createFriendLobby().unwrap()
      openModal("playWithFriend")
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <HomeMenuItem
      className={clsx(styles.WithFriends, className)}
      classNameContent={clsx(styles.WithFriends_content)}
      {...rest}
      title={t("playWithFriend.title")}
      button={{
        title: t("createLink"),
        styles: "yellow",
        disabled: isMatchSearching,
        isLoading: isCreating,
        onClick: handleCreateLink
      }}
      isDisabled
    >
      {t("playWithFriend.text")}
      <div className={clsx(styles.WithFriends_friends_img)}>
        <img src={HomeFriendsImg} alt="home friends" />
      </div>
    </HomeMenuItem>
  )
}
